import { App, Form, Input, Modal } from "antd";
import { ApiService } from "api/api.service";
import { AddTaskGroupPayload } from "dtos/tasks/task-template.dto";

interface AddGroupModalProps {
  open: boolean;
  onClose: () => void;
  templateId: string | undefined;
}

/**
 * Modal for adding a new task group to an existing template.
 * Code is optional — the backend auto-generates one if omitted.
 */
export const AddGroupModal = ({ open, onClose, templateId }: AddGroupModalProps) => {
  const [form] = Form.useForm<AddTaskGroupPayload>();
  const { message } = App.useApp();

  const addGroup = ApiService.taskTemplate.useAddGroup(templateId);

  const handleFinish = async (values: AddTaskGroupPayload) => {
    try {
      // Backend expects an array of groups
      await addGroup.mutateAsync([
        {
          name: values.name,
          meta: {},
        },
      ]);
      message.success("Group added");
      form.resetFields();
      onClose();
    } catch {
      message.error("Failed to add group");
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      open={open}
      title="Add Group"
      onCancel={handleCancel}
      onOk={() => form.submit()}
      okText="Add Group"
      okButtonProps={{ loading: addGroup.isPending }}
      centered
      destroyOnHidden
    >
      <Form form={form} layout="vertical" onFinish={handleFinish} style={{ marginTop: 16 }}>
        <Form.Item
          name="name"
          label="Group Name"
          rules={[{ required: true, min: 4, message: "Name must be at least 4 characters" }]}
        >
          <Input placeholder="e.g. Document Collection" />
        </Form.Item>
      </Form>
    </Modal>
  );
};
